import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import SubscriptionExpiredModal from "../Components/Common/SubscriptionExpiredModal";

const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
    const [subscriptionError, setSubscriptionError] = useState(null); 

    return (
        <SubscriptionContext.Provider value={{ subscriptionError, setSubscriptionError }}>
            {children}

            {subscriptionError?.status === 403 && <SubscriptionExpiredModal setSubscriptionError={setSubscriptionError}
                type={subscriptionError?.errorCode === "NO_ACTIVE_SUBSCRIPTION" ? "inactive" : "expire"} />}
        </SubscriptionContext.Provider>
    );
};

export const useSubscription = () => useContext(SubscriptionContext);

SubscriptionProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
